<template>
  <div>
    <router-view />
    <div
      v-if="!['Login', 'Register', 'Forget', 'WeavrWise'].includes($route.name) && isWeavrwise"
    >
      <!-- <div id="main-div" v-if="isChatBtn">
        <div
          class="wave"
          id="main-button"
          :class="{ open: isOpen }"
          @click="toggleButton"
        >
          <font-awesome-icon
            class="messenger-color"
            v-if="isOpen"
            :icon="['fas', 'xmark']"
          ></font-awesome-icon>
          <img
            v-if="isOpen"
            src="https://www.svgrepo.com/show/533030/xmark.svg"
            alt="chat with us"
            class="messenger-color tw-w-[25px]"
          />
          <img v-else src="../public/chatbot.svg" alt="chat with us" />
        </div>
      </div> -->

      <div class="genai-sidebar-modal" v-if="isOpen">
        <GenAiAsideBar :isOpen="isOpen":isDataSource="true" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import GenAiAsideBar from "./views/v3/GenAi/GenAiAsideBar.vue";
export default {
  name: "app",
  components: {
    GenAiAsideBar,
  },
  data() {
    return {
      currentRoute: this.$route.name,
      isChatBtn: false,
      isOpen: false,
      isWeavrwise: false,
    };
  },
  watch: {
    $route: function (to, from) {
      const vm = this;
      vm.isOpen = false;
      if (localStorage.hasOwnProperty("reviewUserData")) {
        let userData = JSON.parse(localStorage.getItem("reviewUserData"));
        Vue.http.headers.common["TOKEN"] = userData.data.token;
        vm.isWeavrwise = userData.data.weavrwise_opted;
        if (userData.userRegister && Vue.http.interceptors.length < 8) {
          Vue.http.interceptors.push(function (request, next) {
            next(function (response) {
              if (response.status == 403) {
                vm.cleanupSession();
                window.location = "#/login";
              }
            });
          });
        }
        if (to.name == "Login") {
          let sb = JSON.parse(localStorage.vocSidebar);
          localStorage.menuIndex = 0;
          window.location = "#" + sb[0].url;
        }
      } else {
        if (
          to.fullPath === "/register" ||
          to.fullPath === "/forget-password" ||
          to.fullPath === "/recovery/" + this.$route.params?.token
        ) {
          return;
        }
        if (to.fullPath.includes("/invite")) {
          return;
        }
        if (this.$route.path == "/create-demo") {
          window.location = "#/create-demo";
        } else {
          window.location = "#/";
        }
      }
    },
  },
  mounted() {
    if (localStorage.getItem("reviewUserData")) {
      this.isChatBtn = true;
    }
  },
  methods: {
    toggleButton() {
      const currentRoute = this.$router.history.current.path;
      localStorage.setItem("currentRoute", currentRoute);
      this.isOpen = !this.isOpen;
    },
    cleanupSession() {
      this.$store.dispatch("DemoStore/resetState");
      localStorage.removeItem("reviewUserData");
      sessionStorage.removeItem("reviewUserData");
      ["vuex"].forEach((key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });
      localStorage.clear();
      sessionStorage.clear();
    },
  },
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
@import "assets/css/responsive.css";
</style>

<style scoped>
#main-div {
  position: fixed;
  right: 75px;
  bottom: 40px;
  z-index: 1;
}

#main-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  height: 50px;
  width: 50px;
  padding: 1px;
  font-size: 20px;
  cursor: pointer;
  background-color: #e7eeee;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 1);
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}

.wave {
  animation-name: wave;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes wave {
  0% {
    box-shadow: 0 0 0px 0px #e7eeee;
  }
  100% {
    box-shadow: 0 0 0px 10px #d1dddd;
  }
}

.open {
  animation-iteration-count: 1;
}

.genai-sidebar-modal {
  position: fixed;
  bottom: 90px;
  right: 100px;
  width: 70vw;
  height: 400px;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px 10px 0 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: transform 0.3s ease-in-out;

  &.slide-in {
    transform: translateY(0);
  }

  &.slide-out {
    transform: translateY(100%);
  }
}
</style>
